/** Phone pages take over below 768px (Gabriel 2026-10-20, the phone guest home); 768 up keeps the desktop layout. */
import { useEffect, useState } from 'react';

import { readSite } from '../site';

export const PHONE_QUERY = '(max-width: 767px)';

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(() => typeof window !== 'undefined' && window.matchMedia(PHONE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(PHONE_QUERY);
    const update = () => setPhone(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  return phone;
}

/**
 * Whether a page draws the app's own screen: on a phone, on the standard website only. A custom
 * site draws Telify's pages with the website's own pieces at every width (web-studio-sites D3, D12;
 * Gabriel 2026-10-25: "Her custom site is her custom site.").
 */
export function useAppScreens(): boolean {
  const phone = useIsPhone();
  return phone && readSite() === null;
}
